module.exports = __webpack_public_path__ + "img/Vector-1.f5395846.png";